.root {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.inner {
    grid-column: 1 / -1;
    height: calc(100vh - var(--main-nav-height));
}
